















import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { CommonAllowedPostSettings } from "@/services/posts/types";

@Component
export default class CommonPostSettings extends Vue {
    @Prop() postSettings!: CommonAllowedPostSettings;
    @Prop() styleOptions!: Style[];
    @Prop() isNew!: boolean;

    defaultValues = { styleId: "" } as CommonAllowedPostSettings;
    localPostSettings = { ...this.defaultValues, ...JSON.parse(JSON.stringify(this.postSettings)) } as CommonAllowedPostSettings;

    mounted() {
        this.setDefaultStyle();
    }

    setDefaultStyle() {
        const styles = this.styleOptions.filter(x => x.id); // Exclude the "no style" option
        if (styles.length > 0 && this.isNew) {
            const defaultStyle = styles.filter(x => x.name.toLowerCase().includes("default"))[0];
            this.localPostSettings.styleId = defaultStyle ? defaultStyle.id : styles[0].id;
        }
    }

    emitData() {
        this.$emit("allowedPostSettingsUpdated", this.localPostSettings);
    }
}
